// @ts-nocheck
import { clearfixStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

// Ensures the "margin-top" that appears on the first block of the content section is not applied for clear fixed blocks (usually with a background).
// See "globalStyle.ts" for the logic that is overridden here.
export const blockContainerClearFixStyles = () => {
    return css`
        ${clearfixStyles()}

        &::before {
            display: table !important;
            margin-top: 0 !important;
        }
    `;
};
